import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['warning'];
  static values = {
    min: { type: Number, default: 18 },
    max: { type: Number, default: 75 }
  };

  connect() {
    // date_selectで生成されたselect要素を取得
    this.yearSelect = this.element.querySelector('select[id$="_1i"]');
    this.monthSelect = this.element.querySelector('select[id$="_2i"]');
    this.daySelect = this.element.querySelector('select[id$="_3i"]');

    // 各select要素にchangeイベントリスナーを追加
    if (this.yearSelect && this.monthSelect && this.daySelect) {
      this.yearSelect.addEventListener('change', this.checkAge.bind(this));
      this.monthSelect.addEventListener('change', this.checkAge.bind(this));
      this.daySelect.addEventListener('change', this.checkAge.bind(this));

      // 初期チェック
      this.checkAge();
    }
  }

  checkAge() {
    const year = parseInt(this.yearSelect.value);
    const month = parseInt(this.monthSelect.value);
    const day = parseInt(this.daySelect.value);

    // 有効な日付かチェック
    if (!year || !month || !day) {
      this.hideWarning();
      return;
    }

    const birthday = new Date(year, month - 1, day);
    const age = this.calculateAge(birthday);

    if (age < this.minValue || age >= this.maxValue) {
      this.showWarning();
    } else {
      this.hideWarning();
    }
  }

  calculateAge(birthday) {
    const today = new Date();
    let age = today.getFullYear() - birthday.getFullYear();
    const monthDiff = today.getMonth() - birthday.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthday.getDate())) {
      age--;
    }

    return age;
  }

  showWarning() {
    this.warningTarget.style.display = 'block';
  }

  hideWarning() {
    this.warningTarget.style.display = 'none';
  }
}
